export default __webpack_public_path__ + "media/gs_upgrade_email/yt-db1f6159.png";